import { useState } from 'react';

export function useCustomerSelection() {
  const [selectedCustomers, setSelectedCustomers] = useState(new Set());

  const handleSelectAll = (checked, customerData) => {
    if (checked) {
      const allIds = new Set(customerData.map(customer => customer._id));
      setSelectedCustomers(allIds);
    } else {
      setSelectedCustomers(new Set());
    }
  };

  const handleSelectCustomer = (customerId, checked) => {
    const newSelection = new Set(selectedCustomers);
    if (checked) {
      newSelection.add(customerId);
    } else {
      newSelection.delete(customerId);
    }
    setSelectedCustomers(newSelection);
  };

  const clearSelection = () => {
    setSelectedCustomers(new Set());
  };

  const getSelectionState = (customerData) => {
    const isAllSelected = customerData.length > 0 && selectedCustomers.size === customerData.length;
    const isIndeterminate = selectedCustomers.size > 0 && selectedCustomers.size < customerData.length;
    
    return { isAllSelected, isIndeterminate };
  };

  return {
    selectedCustomers,
    handleSelectAll,
    handleSelectCustomer,
    clearSelection,
    getSelectionState
  };
}
